const kmData = {
    activeUsers: [
        {
          id: 201,
          image: '',
          unit: 'KEMENTERIAN KELAUTAN DAN PERIKANAN',
          name: 'Sakti Wahyu Trenggono',
        },
        {
          id: 202,
          image: '',
          unit: 'BADAN RISET DAN SUMBER DAYA MANUSIA KELAUTAN DAN PERIKANAN',
          name: 'I Nyoman Radiarta',
        },
        {
          id: 203,
          image: '',
          unit: 'SEKRETARIAT BADAN RISET DAN SUMBER DAYA MANUSIA KELAUTAN DAN PERIKANAN',
          name: 'Kusdiantoro',
        },
        {
          id: 204,
          image: '',
          unit: 'LOKA RISET SUMBERDAYA DAN KERENTANAN PESISIR, PADANG',
          name: 'NIA NAELUL HASANAH RIDWAN',
        },
        {
          id: 205,
          image: '',
          unit: 'BALAI BESAR RISET BUDIDAYA LAUT DAN PENYULUHAN PERIKANAN, GONDOL BULELENG SINGARAJA',
          name: 'WAWAN ANDRIYANTO',
        },
      ],
}

export default kmData;